export const conference = {
    "入会注意事项(必读)":"入会注意事项(必读)",
    "(1/3)请选择“加入会议”下载/调起腾讯会议app进入会议":"(1/3)请选择“加入会议”下载/调起腾讯会议app进入会议；",
    "(2/3)请务必使用与课堂派注册/绑定的手机":"(2/3)请务必使用与课堂派注册/绑定的手机；",
    "登陆腾讯会议":"登陆腾讯会议；",
    "(3/3)登陆后选择“课堂派”账号后直接进入会议":"(3/3)登陆后选择“课堂派”账号后直接进入会议；",
    "知道了":"知道了",
    "距开始":"",
    "距离开始时间":"to start",
    "主持人":"Host:",
    "来自":"From:",
    "会议名称":"Meeting name",
    "开始时间":"Start time",
    "结束时间":"End time",
    "会议简介":"Introduction",
    "应用环节":"Application link",
    "所属章节":"Chapter",
    "同时发布给学生":"Publish to students",
    "会议添加成功":"Meeting added successfully!",
    "更新成功":"Update successfully!",
    "预约的会议":"'s meeting",
    "正在跳转至腾讯会议请稍候":"Jumping to Tencent conference, please wait",
    "选择本次会议的录屏":"Select the screen recording of this meeting:",
    "录屏":"Screen recording",
    "确定关联":"Confirm",
    "关联成功":"Association succeeded",
    "关联后的录屏可在会议详情中查看":"The associated screen recording can be viewed in the meeting details",
    "暂无会议回放录屏":"No conference playback recording screen!",
    "去关联录屏":"Associate screen recording",
    "倒计时":"Count down:",
    "学生下载权限设置":"Student download permission settings",
    "重新关联":"Reassociate",
    "权限设置":"Permission settings",
    "修改会议":"Modify meeting",
    "取消会议":"Cancel meeting",
    "复制邀请":"Copy meeting",
    "您是否要删除该直播回放":"Do you want to delete the live broadcast playback",
    "邀请信息复制成功":"Invitation information copied successfully",
    "复制失败":"Copy failed",
    "确定要删除会议吗":"Are you sure to delete the meeting",
    "再看看":"Later",
    "确定要取消会议吗":"Are you sure to cancel the meeting",
    "取消成功":"Cancel successfully!",
    "发布会议":"Release meeting",
    "关联录屏":"Associate screen recording",
    "已关联":"Associated",
    "请输入会议名称":"Please enter a conference name",
    "会议封面":"Meeting cover",
    "点击选择时间":"Click to select the time",
    "会议描述":"Meeting description",
    "会议名称不允许为空":"The conference name cannot be empty",
    "会议结束时间不能小于开始时间":"The end time of the meeting cannot be less than the start time",
    "名称":"name",
    "请输入名称内容":"Please enter the name",
    "视频内容":"Video content",
    "描述":"Detail",
    "编辑文章":"Edit article",
    "视频封面":"Video cover",
    "编辑视频内容":"Edit video content",
    "视频内容不允许为空":"Video content cannot be empty",
    "名称不允许为空":"Name cannot be empty",
    "视频":"video",
    "申请加入虚拟教研室可以和名师一起探讨教学哦":"To apply for joining the virtual teaching and research department, you can discuss teaching with famous teachers~",
    "暂无会议简介":"No conference introduction",
    "展开":"Expand",
    "参与":"participate in",
    "相关推荐":"Related recommendations",
    "次浏览":"views ",
    "条评论":"comments",
    "暂无相关推荐":"No recommendation",
    "个人版":"Personal Edition",
    "企业版":"Enterprise Edition",
    "有回放":"Playback",
}
